import React, { useMemo } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import {
  SET_CORRESPONDENCE2_REDUCER,
  SET_CORRESPONDENCE_RECIPIENT,
} from '../Correspondence2Reducer'
import { getStateOptions, getCountryOptions } from '../../Wizard2/selectOptions'
import { isCountryUSA } from '../../../Utilities/Utilities'

const ContactInfoStep = () => {
  const dispatch = useDispatch()
  const corrInfo = useSelector((state) => state.correspondence2, shallowEqual)
  const { isEmail, isSnailMail, CustomCorrespondenceRecipient, readOnly } = corrInfo
  const { Email, Name, /*To,*/ Address1, Address2, Address3, City, State, PostalCode, Country } =
    CustomCorrespondenceRecipient

  const countryIsUSA = useMemo(() => {
    return isCountryUSA(Country)
  }, [Country])

  return (
    <div className="corr-field-container">
      <Checkbox
        checked={isEmail}
        onChange={(checked) =>
          dispatch({ type: SET_CORRESPONDENCE2_REDUCER, payload: { isEmail: checked } })
        }
        label="Email"
        disabled={readOnly ? true : undefined}
      />
      {isEmail && (
        <div className="corr-field-container">
          {' '}
          <TextInput
            label={
              <span>
                <span style={{ color: `hsl(345,100%,42%)` }}>*</span>Email
              </span>
            }
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'Email',
                value: e.target.value,
              })
            }
            value={Email}
            disabled={readOnly ? true : undefined}
          />
        </div>
      )}

      <Checkbox
        checked={isSnailMail}
        onChange={(checked) =>
          dispatch({ type: SET_CORRESPONDENCE2_REDUCER, payload: { isSnailMail: checked } })
        }
        label="Print and Mail"
        disabled={readOnly ? true : undefined}
      />
      {isSnailMail && (
        <div className="corr-field-container">
          <TextInput
            label={
              <span>
                <span style={{ color: `hsl(345,100%,42%)` }}>*</span>In Regards to
              </span>
            }
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'Name',
                value: e.target.value,
              })
            }
            value={Name}
            disabled={readOnly ? true : undefined}
          />
          {/* <TextInput
            label="In Care of"
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'To',
                value: e.target.value,
              })
            }
            value={To || ''}
            disabled={readOnly ? true : undefined}
          /> */}
          <TextInput
            label={
              <span>
                <span style={{ color: `hsl(345,100%,42%)` }}>*</span>
                {countryIsUSA ? 'Address' : 'Address 1'}
              </span>
            }
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'Address1',
                value: e.target.value,
              })
            }
            value={Address1}
            disabled={readOnly ? true : undefined}
          />
          <TextInput
            label={
              <span>
                <span style={{ color: `hsl(345,100%,42%)` }}>{countryIsUSA ? '' : '*'}</span>
                {countryIsUSA ? 'STE/APT/FL' : 'Address 2'}
              </span>
            }
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'Address2',
                value: e.target.value,
              })
            }
            value={Address2}
            disabled={readOnly ? true : undefined}
          />
          <TextInput
            label={
              <span>
                <span style={{ color: `hsl(345,100%,42%)` }}>{countryIsUSA ? '' : '*'}</span>
                {countryIsUSA ? 'Attention' : 'Address 3'}
              </span>
            }
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'Address3',
                value: e.target.value,
              })
            }
            value={Address3}
            disabled={readOnly ? true : undefined}
          />
          {countryIsUSA ? (
            <div className="city-state-row">
              <TextInput
                label={
                  <span>
                    <span style={{ color: `hsl(345,100%,42%)` }}>*</span>City
                  </span>
                }
                onChange={(e) =>
                  dispatch({
                    type: SET_CORRESPONDENCE_RECIPIENT,
                    accessor: 'City',
                    value: e.target.value,
                  })
                }
                value={City}
                disabled={readOnly ? true : undefined}
              />
              <SelectBox
                placeholder=""
                label={
                  <span>
                    <span style={{ color: `hsl(345,100%,42%)` }}>*</span>State
                  </span>
                }
                options={getStateOptions()}
                onChange={(e) =>
                  dispatch({
                    type: SET_CORRESPONDENCE_RECIPIENT,
                    accessor: 'State',
                    value: e,
                  })
                }
                value={State}
                disabled={readOnly ? true : undefined}
              />
              <TextInput
                label={
                  <span>
                    <span style={{ color: `hsl(345,100%,42%)` }}>*</span>ZIP Code
                  </span>
                }
                onChange={(e) =>
                  dispatch({
                    type: SET_CORRESPONDENCE_RECIPIENT,
                    accessor: 'PostalCode',
                    value: e.target.value,
                  })
                }
                value={PostalCode}
                disabled={readOnly ? true : undefined}
              />
            </div>
          ) : null}
          <SelectBox
            noPlaceholder
            label="Country"
            options={getCountryOptions()}
            onChange={(e) =>
              dispatch({
                type: SET_CORRESPONDENCE_RECIPIENT,
                accessor: 'Country',
                value: e,
              })
            }
            value={Country}
            disabled={readOnly ? true : undefined}
          />
        </div>
      )}
    </div>
  )
}

export default ContactInfoStep

export const isContactInfoStepValid = (corrInfo) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const { isEmail, isSnailMail } = corrInfo
  const { Email, Name, Address1, Address2, Address3, City, State, PostalCode, Country } =
    corrInfo.CustomCorrespondenceRecipient

  if (!isEmail && !isSnailMail) return false

  if (isEmail && !emailRegex.test(Email)) return false

  if (isSnailMail) {
    if (isCountryUSA(Country)) {
      if (!Name || !Address1 || !City || !State || !PostalCode) return false
    } else {
      if (!Name || !Address1 || !Address2 || !Address3) return false
    }
  }
  return true
}
